// strip the "https://" or "http://" from the beginning of a URL
export const getDomain = (url: string): string | null => {
  if (!url || url.trim() === '') return null;
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname;
  } catch (error) {
    console.warn('Invalid URL for getDomain', error);
    return null;
  }
};

// Utilize Google's favicon domain service to get the favicon for a given URL
export const getFaviconUrl = (url: string): string => {
  if (!url || url.trim() === '') return '';
  try {
    const parsedUrl = new URL(url);
    // return `https://www.google.com/s2/favicons?domain=${parsedUrl.hostname}&sz=16`;
    // Let's try duck duck go instead.
    return `https://icons.duckduckgo.com/ip3/${parsedUrl.hostname}.ico`;
  } catch (error) {
    console.warn('Invalid URL for Favicon', error);
    return '';
  }
};

// Some tools around url cleaning

const disalowedParams: string[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
  'msclkid',
  'dclid',
  'utm_referrer',
  'utm_social',
  'utm_social-type',
  'utm_place',
  'hmb_campaign',
  'hmb_medium',
  'hmb_source',
  'igshid',
  'mat_click_id',
  'mc_eid',
  'mc_cid',
  'mkt_tok',
  'trk',
  'trkCampaign',
  'elqTrackId',
  'elqTrack',
  'ncid',
  'aff_platform',
  'aff_trace_key',
  'campaigntype',
  'adgroupid',
  'creative',
  'keyword',
  'matchtype',
  'network',
  'device',
  'devicemodel',
  'adposition',
  'placement',
  'target',
  'aceid',
  'anid',
  'cid',
  'eid',
  'pid',
  'tid',
  'tsid',
];

// Clean the URL to remove any tracking parameters and hash tags
export const normalizeUrl = (url: string): string => {
  const urlObj = new URL(url);
  disalowedParams.forEach((param) => {
    urlObj.searchParams.delete(param);
  });
  urlObj.hash = '';
  return urlObj.toString();
};
